// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__k6M8Q","title":"styles_title__38nkp"};